<style lang="scss" scoped>
::v-deep .tns-visually-hidden {
    display: none;
}
::v-deep .tns-nav {
    display: flex;
    button {
        width: 100%;
        background: #cccccc;
        border: none;
        box-shadow: none;
        height: 1px;
        padding: 0px;
        transition: background 0.15s ease-in-out;
        &.tns-nav-active {
            background: #000;
            height: 2px;
            border-radius: 5px;
            margin-top: -1px;
        }
    }
}
</style>

<template>
    <div class="row">
        <div class="container">
            <div v-if="title || cta" class="mb-40 d-flex flex-wrap w-100">
                <h3 v-if="title" v-html="title" class="title"></h3>
                <a v-if="cta" :href="route('nl.activities')" class="ml-auto my-auto link-arrow">{{ cta }} <span class="arrow-right" v-html="svg('arrow-right')" /></a>
            </div>
            <div v-if="activities" class="activities-slider">
                <div v-for="col in Math.round(activities.length / 2)" :key="col">
                    <activity-card class="activity-card mb-40" :activity="maybeGetActivity(col - 1)" :ratio="ratio" />
                    <activity-card class="activity-card mb-40" :activity="maybeGetActivity((col - 1) + Math.round(activities.length / 2))" :ratio="ratio" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { tns } from "tiny-slider/src/tiny-slider.module"
import activitesRow from "./activities-row";

export default {
    name: "pagePart.activities-slider-row",

    mixins: [activitesRow],

    mounted() {
        var slider = tns({
            container: '.activities-slider',
            items: 4,
            slideBy: 1,
            autoplay: false,
            gutter: 24,
            controls: false,
            navPosition: 'bottom',
            mouseDrag: true,
            navAsThumbnails: true,
            loop: false
        });
    },

    methods: {
        maybeGetActivity(index) {
            if (this.activities.length - 1 >= index) {
                return this.activities[index];
            } else {
                return null;
            }
        },
    }
}
</script>